var fileList = 
    [
     
     
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_3.png?v=1692362216",
     

      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_13.png?v=1692363402",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_12.png?v=1692363402",


      "https://cdn.shopify.com/s/files/1/1213/6334/files/491603767_1327938155430671_3592345012892472944_n.jpg?v=1778753052",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/491968053_1327938262097327_3657472789883538842_n.jpg?v=1778753053",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/491741776_1327938348763985_8587652918466846525_n.jpg?v=1778753053",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/491445634_1327938298763990_6074186932665418238_n.jpg?v=1778753053",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/491832192_1327938275430659_5200165851577231535_n.jpg?v=1778753052",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/492179671_1327938165430670_2888693459614389188_n.jpg?v=1778753052",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/491843547_1327938305430656_7660657340373390929_n.jpg?v=1778753052",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/492022590_1327938308763989_660100403341832797_n.jpg?v=1778753053",

     

      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_9.png?v=1692363404",


      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito-baby-breath-arch.png?v=1778860947",

      
      "https://cdn.shopify.com/s/files/1/1213/6334/files/275072368_964343850859282_3224111940106866412_n.jpg?v=1646670126",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_kzau_floristika.png?v=1646670763",

      
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_2.png?v=1692362217",

      

      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_17.png?v=1692363402",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_16.png?v=1692363403",

      
      
      
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_14.png?v=1692363403",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_15.png?v=1692363403",


      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_11.png?v=1692363402",
      
      "https://cdn.shopify.com/s/files/1/1213/6334/files/Tacito_kaazas_14.jpg?v=1646670126",

      

      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_20.png?v=1692448848",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_22.png?v=1692448849",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_19.png?v=1692448848",
      
      
      
      
      "https://cdn.shopify.com/s/files/1/1213/6334/files/Tacito_kaazas_11__2.jpg?v=1646672001",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/Tacito_kaazas_13.jpg?v=1646670247",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_6.png?v=1692363403",
     
     
      "https://cdn.shopify.com/s/files/1/1213/6334/files/Tacito_kaazas_9.jpg?v=1646670126",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/Tacito_kaazas_7.jpg?v=1646670126",
      
      
      
      
      "https://cdn.shopify.com/s/files/1/1213/6334/files/IMG-20210731-WA0002.jpg?v=1628394691",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/IMG-20210731-WA0001.jpg?v=1628394691",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/IMG-20210731-WA0004.jpg?v=1628394691",
      
      "https://cdn.shopify.com/s/files/1/1213/6334/files/IMG-20210731-WA0003.jpg?v=1628394691",
      
      "https://cdn.shopify.com/s/files/1/1213/6334/files/68948193_2502405513323096_994783144137118089_n.jpg?v=1590016619",
    
      
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-kazufloristika.png?4193",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_5.png?v=1692363403",
      
      "https://cdn.shopify.com/s/files/1/1213/6334/files/Tacito_kaazas_1.jpg?v=1646671415",
      
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-kazufloristika_2021.png?v=1615836474",
      
       


      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-3.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-1.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-2.jpg?2723",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/IMG-20200331-WA0003.jpg?v=1590015052",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/IMG-20200331-WA0004.jpg?v=1590015052",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito-K-2018-5.jpg?4193",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito-K-2018-4.jpg?4193",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito-K-2018-3.jpg?4193",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito-K-2018-1.jpg?4193",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-18.jpg?4193",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-18-2.jpg?4193",



      "https://cdn.shopify.com/s/files/1/1213/6334/files/70288191_920783388276465_5094538559809912832_o.jpg?v=1590016790",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi.jpg?v=1590019069",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/69689178_920783354943135_8052701493997862912_o.jpg?v=1590016790",



      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-14-2.jpg?4193",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-14-1-1.jpg?4193",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/RD_print-1407_web.png?v=1590016166",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/RD_print-1386.jpg?v=1590015073",


      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-13-2.jpg?4193",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-13-1.jpg?4193",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-12-6.jpg?4193",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-12-1.jpg?4193",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-12-3.jpg?4193",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-12-2.jpg?4193",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-12-4.jpg?4193",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-17-1.jpg?4195",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-17-2.jpg?4195",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito-K-190-4.jpg?4193",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacitoziedi-KF-17-3.jpg?4195",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito-K-22.jpg?4195",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito-K-10-2.jpg?4195",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito-K-10-3.jpg?4195",


      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-30.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-31.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-32.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-33.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-34.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-35.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-40.jpg?2723",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito-K-47-2.jpg?4353",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-50.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-51.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-52.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-53.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-54.jpg?2723",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/ziedi_tacito_1.jpg?v=1590017555",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/51648864_1906330836143735_8968775102921441280_o.jpg?v=1590017764",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/Emils-Kristiana-526.jpg?v=1590018639",

      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-60.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-61.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-62.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-63.jpg?2723",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-64.jpg?4353",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito-K-42-3.jpg?4365",
      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito-K-42-2.jpg?4365",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/170608_119.jpg?v=1590017427",

      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-7.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-5.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-19.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-8.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-11.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-13.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-16.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-18.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-20.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-6.jpg?2723",
      "https://cdn2.shopify.com/s/files/1/1213/6334/files/ziedi-tacito-kf-2018-4.jpg?2723",
      
       
      "https://cdn.shopify.com/s/files/1/1213/6334/files/Tacito_kaazas.jpg?v=1646670126",
      

      "https://cdn.shopify.com/s/files/1/1213/6334/files/1_95a5de5c-b9f9-4c2f-9433-c0c26ec0b074.jpg?v=1590018759",

      "https://cdn.shopify.com/s/files/1/1213/6334/files/tacito_ziedi_wedding_7.png?v=1692363403",
      
      
    ];


      $(document).ready(function () {


      var $gallery = $('.slick-gallery')
      	.addClass("embla")
      	.append("<div class='embla__container'>");
      
      if($gallery.length === 0) {
      	return;
      }

      var container = $($gallery.children()[0]);   

for(var i = 0; i < fileList.length; i++) {

  var content = 
      [
        "<div class='embla__slide'>",
        "<div class='embla__slide__inner'>",

        "<img data-src='",
        fileList[i],
        "'",

        " src='",
        "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D'",

        " alt='",
        fileList[i],
        "'",

        " class='embla__slide__img'",
        " />",
        "</div>",
        "</div>"
      ].join('');

  container.append(content);
}

var tacitoArrow1 = '<svg class="embla__button__svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="595.28px" height="841.89px" viewBox="0 0 595.28 841.89" enable-background="new 0 0 595.28 841.89" xml:space="preserve"><path fill-rule="evenodd" clip-rule="evenodd" stroke="#FFFFFF" stroke-width="20" stroke-miterlimit="10" d="M469.18,428.763  C363.544,321.969,258.192,215.462,152.804,108.918c3.822-3.628,7.472-7.094,11.493-10.911  c108.714,109.901,217.779,220.159,327.18,330.754C382.305,539.129,273.236,649.393,164.489,759.331  c-3.758-3.727-7.389-7.327-11.253-11.16C258.14,642.117,363.492,535.609,469.18,428.763z"/></svg>';

var buttonPrev = $('<button class="embla__button embla__button--prev" type="button"></button>');
buttonPrev.append(tacitoArrow1);

var buttonNext = $('<button class="embla__button embla__button--next" type="button"></button>');
buttonNext.append(tacitoArrow1);

$gallery.append(buttonPrev);
$gallery.append(buttonNext);
 
var emblaOptions = {
  align: 'start',
  dragFree: true,
  containScroll: "keepSnaps",
  loop: true
};

var viewPort = $gallery[0];
var prevBtn = buttonPrev[0];
var nextBtn = buttonNext[0];

var onLoaded = function() {

  var embla = EmblaCarousel(viewPort, emblaOptions);

  setupPrevNextBtns(prevBtn, nextBtn, embla);
  var disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, embla);

  embla.on("init", disablePrevAndNextBtns);
  embla.on("select", disablePrevAndNextBtns);
  
};

var lazyLoadInstance = lazyLoad(viewPort)();

lazyLoadInstance.on("loaded", onLoaded);

});

function setupPrevNextBtns (prevBtn, nextBtn, embla) {
  prevBtn.addEventListener('click', embla.scrollPrev, false);
  nextBtn.addEventListener('click', embla.scrollNext, false);
};

function disablePrevNextBtns (prevBtn, nextBtn, embla) {
  return () => {
    if (embla.canScrollPrev()) prevBtn.removeAttribute('disabled');
    else prevBtn.setAttribute('disabled', 'disabled');

    if (embla.canScrollNext()) nextBtn.removeAttribute('disabled');
    else nextBtn.setAttribute('disabled', 'disabled');
  };
};

function lazyLoad($gallery) {
  
  var slides = $gallery.querySelectorAll(".embla__slide");//embla.slideNodes();
  var images = $gallery.querySelectorAll(".embla__slide__img");
  var imagesInView = [];
  var eventHandlers = [];

  var onEvent = function(eventName, callback) {
    
    if(eventName === "loaded") {
      eventHandlers.push(callback);
    }
   
  }
  
  var onLoad = function() {

    var loadedAll = imagesInView.length === images.length;
    
    if(loadedAll) {
      eventHandlers.forEach(function(handler) {
        handler({ loadedAll: loadedAll });
      });
    }
  }
  
  var addImageLoadEvent = (image, callback) => {
    image.addEventListener("load", callback);
    return () => image.removeEventListener("load", callback);
  };

  var loadImagesInView = () => {
    
    slides.forEach(function(slide, index) {
      loadImageInView(index);
    });
  };

  var loadImageInView = index => {

    var image = images[index];
    var slide = slides[index];

    image.src = image.getAttribute("data-src");

    var removeImageLoadEvent = addImageLoadEvent(image, () => {
        slide.classList.add("has-loaded");
    	removeImageLoadEvent();
    	imagesInView.push(index);
//     	console.log("onLoad", index);
		onLoad();
  });
};

  return () => {
    loadImagesInView();
    return {
      loadedAll: imagesInView.length === images.length,
      loaded: imagesInView.length,
      on: onEvent
    };
  };
};
